import { render, staticRenderFns } from "./tech.vue?vue&type=template&id=30c67d12&scoped=true&"
import script from "./tech.vue?vue&type=script&lang=js&"
export * from "./tech.vue?vue&type=script&lang=js&"
import style0 from "./tech.vue?vue&type=style&index=0&id=30c67d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c67d12",
  null
  
)

export default component.exports